module.exports = __webpack_public_path__ + "static/media/boat-img-43.c2539e92.jpg";